import { LoadingSpinner } from '@employ-engage/common-components';
import { useParams } from 'react-router-dom';
import { useEffect, ReactNode, useState } from 'react';

export const InviteAcceptancePage = () => {
  const { inviteId } = useParams();
  const [tsxContent] = useState<ReactNode | null>(null);

  useEffect(() => {
    if (inviteId) {
      // getDoc(getJoinCompanyInvitationDocRef(company.id, inviteId))
      //   .then((doc) => {
      //     if (doc.exists()) {
      //       const invitation = FirestoreJoinCompanyInvitation.fromFirestore(
      //         doc,
      //         {}
      //       );
      //       getUserWithEmail(invitation.userEmail)
      //         .then((user) => {
      //           if (user) {
      //             updateUserWithCompanyId(user, company.id).then(() => {
      //               deleteDoc(
      //                 getJoinCompanyInvitationDocRef(company.id, inviteId)
      //               )
      //                 .then(() => {
      //                   setTsxContent(
      //                     <div className="flex flex-col justify-center items-center pt-10">
      //                       <h1 className="text-lg font-bold">
      //                         {t('You have successfully accepted your invite!')}
      //                       </h1>
      //                       <p>{t('Click the button below to sign in.')}</p>
      //                       <Button to={'/?signin=true'} variant="primary">{t('Sign in')}</Button>
      //                     </div>
      //                   );
      //                 })
      //                 .catch(() => {
      //                   console.error('Unable to delete the invitation');
      //                 });
      //             });
      //           } else {
      //             setTsxContent(
      //               <CreateAccountForm
      //                 onAccountCreated={(userCredential) => {
      //                   try {
      //                     let attemptsLeft = 3;
      //                     let isSuccessful = false;
      //                     const interval = setInterval(async () => {
      //                       if (attemptsLeft === 0 || isSuccessful) {
      //                         // remove interval
      //                         clearInterval(interval);
      //                       } else {
      //                         const userDoc = await getDoc(
      //                           getUserDocRef(userCredential.user.uid)
      //                         );
      //                         if (userDoc.exists()) {
      //                           const user = FirestoreUser.fromFirestore(
      //                             userDoc,
      //                             {}
      //                           );
      //                           await updateUserWithCompanyId(user, company.id);
      //                           await deleteDoc(
      //                             getJoinCompanyInvitationDocRef(
      //                               company.id,
      //                               inviteId
      //                             )
      //                           );
      //                           setTsxContent(
      //                             <div className="flex flex-col justify-center items-center pt-10">
      //                               <h1 className="text-lg font-bold">
      //                                 {t(
      //                                   'You have successfully accepted your invite!'
      //                                 )}
      //                               </h1>
      //                               <p>
      //                                 {t(
      //                                   'Click the button below to navigate to the Admin Portal.'
      //                                 )}
      //                               </p>
      //                               <Button to={'/admin'}>
      //                                 {t('Go to Admin Portal')}
      //                               </Button>
      //                             </div>
      //                           );
      //                           isSuccessful = true;
      //                         } else {
      //                           attemptsLeft -= 1;
      //                         }
      //                       }
      //                     }, 5000);
      //                   } catch (e) {
      //                     console.info(e);
      //                   }
      //                 }}
      //               />
      //             );
      //           }
      //         })
      //         .catch((e) => {
      //           console.error('unable to get user with email: ', e);
      //         });
      //     } else {
      //       console.info('invitation does NOT exist');
      //     }
      //   })
      //   .catch((e) => {
      //     console.error('cannot get invitation: ', e);
      //   });
    }
  }, [inviteId]);

  if (!tsxContent) {
    return <LoadingSpinner spinnerId="invite-acceptance-page-loading" />;
  } else {
    return tsxContent;
  }
};

export default InviteAcceptancePage;
